import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/capacitor';

export async function setNativeVersionTags(): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    return;
  }
  try {
    const info = await App.getInfo();
    if (info.version) {
      Sentry.setTag('native_version', info.version);
    }
    if (info.build) {
      Sentry.setTag('native_build', info.build);
    }
  } catch (error) {
    console.warn('Failed to set native version sentry tags', error);
  }
}
